// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"314fd6d1","455":"0f91770e","977":"f662f611"}[chunkId] + ".chunk.js";
};